import { Component } from "react";
import { Button, Container, Header } from "./Styles";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("ErrorBoundary caught an error", error, errorInfo);
  }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;

    if (hasError) {
      return (
        <Container>
          <article style={{ padding: "100px" }}>
            <Header>Something went wrong.</Header>
            <Button onClick={() => window.location.reload()}>
              Reload Page
            </Button>
          </article>
        </Container>
      );
    }

    return children;
  }
}

export default ErrorBoundary;
